"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditMatrixDialogContextProvider = exports.decorateFreqConsList = exports.EditMatrixTabIndices = void 0;
var React = require("react");
var urls_1 = require("../../urls");
var matrixUtils_1 = require("../../components/admin/matrixUtils");
var EditMatrixTabIndices = (function () {
    function EditMatrixTabIndices(matrix) {
        this.EXPLICIT_EVAL = 1;
        this.FREQUENCY_DISPLAY = this.EXPLICIT_EVAL + 1;
        this.FREQUENCY_START = this.FREQUENCY_DISPLAY + 1;
        this.CONSEQUENCE_DISPLAY = this.FREQUENCY_START + (matrix.row_headers.length * 3);
        this.RISK_RESERVE = this.CONSEQUENCE_DISPLAY + 1;
        this.BUDGET = this.RISK_RESERVE + 1;
        this.BUDGET_UPDATE = this.BUDGET + 1;
        this.SCALE_WITH_BUDGET = this.BUDGET_UPDATE + 1;
        this.CONSEQUENCE_START = this.SCALE_WITH_BUDGET + 1;
        this.CONSEQUENCE_OFFSET = matrix.column_headers.length * 3;
        this.SAVE = this.CONSEQUENCE_START + (this.CONSEQUENCE_OFFSET * 2) + 1;
    }
    return EditMatrixTabIndices;
}());
exports.EditMatrixTabIndices = EditMatrixTabIndices;
function decorateFreqConsList(instances, startTab) {
    var count = instances.length;
    return instances.map(function (obj, i) { return ({
        instance: obj,
        lowTabIndex: i * 3 + startTab,
        midTabIndex: i * 3 + startTab + 1,
        highTabIndex: i * 3 + startTab + 2,
        next: i < count - 1 ? instances[i + 1] : null,
        prev: i > 0 ? instances[i - 1] : null,
    }); });
}
exports.decorateFreqConsList = decorateFreqConsList;
var initialState = {
    isOpen: false,
    isReady: false,
    matrix: null,
    budget: null,
    risk_reserve: null,
    tabIndices: null,
    row_headers: [],
    column_headers: [],
    consequences: [],
    formErrors: undefined,
};
var EditMatrixDialogContext = React.createContext(__assign(__assign({}, initialState), { openDialog: undefined, closeDialog: undefined, onChangeMatrix: undefined, onChangeBudget: undefined, onChangeReserve: undefined, updateConsequencesFromBudget: undefined, onChangeFrequency: undefined, onChangeConsequenceValue: undefined, onChangeConsequencePercentile: undefined, onSave: undefined }));
exports.default = EditMatrixDialogContext;
var EditMatrixDialogContextProvider = (function (_super) {
    __extends(EditMatrixDialogContextProvider, _super);
    function EditMatrixDialogContextProvider(props) {
        var _this = _super.call(this, props) || this;
        _this.onSaveSuccessCallback = undefined;
        _this.state = __assign({}, initialState);
        return _this;
    }
    EditMatrixDialogContextProvider.prototype.openDialog = function (matrix, onSaveSuccessCallback) {
        this.onSaveSuccessCallback = onSaveSuccessCallback;
        var newMatrix = (0, matrixUtils_1.deepCopyMatrix)(matrix);
        newMatrix.row_headers = newMatrix.row_headers.reverse();
        var tabIndices = new EditMatrixTabIndices(newMatrix);
        this.setState({
            isOpen: true,
            isReady: true,
            tabIndices: tabIndices,
            matrix: newMatrix,
            budget: newMatrix.budget ? newMatrix.budget.toString() : "0",
            risk_reserve: newMatrix.risk_reserve ? newMatrix.risk_reserve.toString() : "0",
            column_headers: decorateFreqConsList(newMatrix.column_headers, tabIndices.FREQUENCY_START),
            row_headers: decorateFreqConsList(newMatrix.row_headers, tabIndices.CONSEQUENCE_START),
            consequences: ((newMatrix.orientation == 10) ?
                decorateFreqConsList(newMatrix.column_headers, tabIndices.FREQUENCY_START) :
                decorateFreqConsList(newMatrix.row_headers, tabIndices.CONSEQUENCE_START)),
            formErrors: undefined,
        });
    };
    EditMatrixDialogContextProvider.prototype.closeDialog = function () {
        this.onSaveSuccessCallback = undefined;
        this.setState({
            isOpen: false,
            isReady: false,
            matrix: null,
            budget: null,
            risk_reserve: null,
            tabIndices: null,
            column_headers: [],
            row_headers: [],
            formErrors: undefined,
        });
    };
    EditMatrixDialogContextProvider.prototype.onChangeMatrix = function (attr, value) {
        this.setState(function (prev) {
            prev.matrix[attr] = value;
            return {
                matrix: prev.matrix,
                formErrors: undefined,
            };
        });
    };
    EditMatrixDialogContextProvider.prototype.onChangeBudget = function (value) {
        this.setState(function (prev) {
            prev.matrix.budget = parseFloat(value);
            return {
                matrix: prev.matrix,
                row_headers: prev.row_headers,
                budget: value,
                formErrors: undefined,
            };
        });
    };
    EditMatrixDialogContextProvider.prototype.onChangeReserve = function (value) {
        this.setState(function (prev) {
            prev.matrix.risk_reserve = parseFloat(value);
            return {
                matrix: prev.matrix,
                risk_reserve: value,
                formErrors: undefined,
            };
        });
    };
    EditMatrixDialogContextProvider.prototype.updateConsequencesFromBudget = function () {
        this.setState(function (prev) {
            var budget = parseFloat(prev.budget);
            var scale_with_budget = prev.matrix.scale_with_budget;
            if (scale_with_budget && !isNaN(budget) && budget > 0) {
                prev.consequences.forEach(function (container) {
                    var cons = container.instance;
                    cons.low = parseFloat((parseFloat(cons.percentile_low.toString()) * budget).toFixed(3));
                    cons.mid = parseFloat((parseFloat(cons.percentile_mid.toString()) * budget).toFixed(3));
                    cons.high = parseFloat((parseFloat(cons.percentile_high.toString()) * budget).toFixed(3));
                });
            }
            return {
                consequences: prev.consequences
            };
        });
    };
    EditMatrixDialogContextProvider.prototype.onChangeFrequency = function (container, attr, value) {
        container.instance[attr] = value;
        if (attr == "high" && container.next) {
            container.next.low = parseFloat(value);
        }
        else if (attr == "low" && container.prev) {
            container.prev.high = parseFloat(value);
        }
        this.setState(function (prev) { return ({
            column_headers: prev.column_headers,
            formErrors: undefined,
        }); });
    };
    EditMatrixDialogContextProvider.prototype.onChangeConsequenceValue = function (container, attr, value, ignore_percentile) {
        var scale_with_budget = this.state.matrix.scale_with_budget;
        var budget = parseFloat(this.state.budget);
        if (scale_with_budget && (isNaN(budget) || budget == 0)) {
            notification(gettext("Invalid budget"), { type: "error" });
            return;
        }
        container.instance[attr] = value;
        var numericValue = parseFloat(value);
        var percentileValue = (numericValue / budget).toString();
        var percentileAttr = "percentile_".concat(attr);
        if (attr == "low" && container.prev)
            container.prev.high = numericValue;
        if (attr == "high" && container.next)
            container.next.low = numericValue;
        if (scale_with_budget && !ignore_percentile)
            this.onChangeConsequencePercentile(container, percentileAttr, percentileValue);
        this.setState(function (prev) { return ({
            row_headers: prev.row_headers,
            formErrors: undefined,
        }); });
    };
    EditMatrixDialogContextProvider.prototype.onChangeConsequencePercentile = function (container, attr, value) {
        container.instance[attr] = value;
        var numericValue = parseFloat(value);
        if (attr == "percentile_low" && container.prev)
            container.prev.percentile_high = numericValue;
        if (attr == "percentile_high" && container.next)
            container.next.percentile_low = numericValue;
        this.setState(function (prev) { return ({
            row_headers: prev.row_headers,
            formErrors: undefined,
        }); });
    };
    EditMatrixDialogContextProvider.prototype.onSave = function (confirm_reevaluation) {
        if (confirm_reevaluation === void 0) { confirm_reevaluation = false; }
        var self = this;
        this.state.matrix.budget = parseFloat(this.state.budget);
        this.state.matrix.risk_reserve = parseFloat(this.state.risk_reserve);
        var postData = {
            matrix: this.state.matrix,
            confirm_reevaluation: confirm_reevaluation,
        };
        return $.ajax((0, urls_1.resolve)(urls_1.Urls.admin_edit_matrix, this.props.project_id, this.state.matrix.id), {
            type: "POST",
            data: JSON.stringify(postData),
            contentType: "application/json",
            complete: function (jqXHR, textStatus) {
                var formErrorRegex = /^(freq|cons|perc)_(\d+)\-(\d+)_(high|mid|low)$/;
                var response = jqXHR.responseJSON;
                if (response && response.errors) {
                    var errors = response.errors;
                    var formErrors = {};
                    if (isObject(errors) && !errors.isArray) {
                        for (var field in errors) {
                            if (errors.hasOwnProperty(field)) {
                                if (formErrorRegex.test(field)) {
                                    formErrors[field] = errors[field].map(function (msg) { return msg; });
                                    delete errors[field];
                                }
                            }
                        }
                        if (formErrors) {
                            self.setState({
                                formErrors: formErrors
                            });
                        }
                    }
                }
                ajaxErrorHandler(jqXHR, textStatus);
            },
            success: function (response) {
                if (response.success) {
                    if (response.warnings && response.warnings.confirm_reevaluation) {
                        fancyConfirm(response.warnings.confirm_reevaluation, function () {
                            self.onSave(true)
                                .then(self.onSaveSuccessCallback);
                        });
                    }
                    else {
                        self.onSaveSuccessCallback && self.onSaveSuccessCallback();
                        self.closeDialog();
                    }
                }
            }
        });
    };
    EditMatrixDialogContextProvider.prototype.render = function () {
        return (React.createElement(EditMatrixDialogContext.Provider, { value: __assign(__assign({}, this.state), { openDialog: this.openDialog.bind(this), closeDialog: this.closeDialog.bind(this), onChangeMatrix: this.onChangeMatrix.bind(this), onChangeBudget: this.onChangeBudget.bind(this), onChangeReserve: this.onChangeReserve.bind(this), updateConsequencesFromBudget: this.updateConsequencesFromBudget.bind(this), onChangeFrequency: this.onChangeFrequency.bind(this), onChangeConsequenceValue: this.onChangeConsequenceValue.bind(this), onChangeConsequencePercentile: this.onChangeConsequencePercentile.bind(this), onSave: this.onSave.bind(this) }) }, this.props.children));
    };
    return EditMatrixDialogContextProvider;
}(React.Component));
exports.EditMatrixDialogContextProvider = EditMatrixDialogContextProvider;
